/**
 * Es un wrapper para los dialogs de confirmación etc.
 * De momento usamos el I18n global
 */
/* global I18n, swal */
import { isEmpty } from 'lodash';

export function confirmar(options) {
  const CONFIRMAR_DEFAULTS = {
    title: I18n.t('Confirmacion'),
    type: 'warning',
    text: I18n.t('seguro_eliminar_registro'),
    showCancelButton: true,
    cancelButtonText: I18n.t('Cancelar'),
    showConfirmButton: true,
    confirmButtonText: I18n.t('Aceptar'),
    confirmButtonColor: '#fe1d12',
    html: true,
  };

  const opts = { ...CONFIRMAR_DEFAULTS, ...options };
  return new Promise((resolve, _reject) => {
    swal(opts, (confirm) => {
      if (confirm === true) {
        resolve(confirm);
      }
    });
  });
}

export function input(options) {
  const DEFAULTS = {
    title: I18n.t('valor'),
    content: 'input',
    type: 'input',
    showCancelButton: true,
    cancelButtonText: I18n.t('Cancelar'),
    showConfirmButton: true,
    confirmButtonText: I18n.t('Aceptar'),
    confirmButtonColor: '#fe1d12',
  };

  const opts = { ...DEFAULTS, ...options };

  return new Promise((resolve, _reject) => {
    swal(opts, (confirm) => {
      if (confirm) {
        resolve(confirm);
      }
    });
  });
}

export function confirmarEliminarFromElement(originalElement) {
  const {
    turboConfirm,
    buttonConfirm,
    buttonCancel,
    showCancel,
    loader,
    close,
    title,
    confirmTitle,
    type,
  } = originalElement.dataset;

  return new Promise((resolve, _reject) => {
    swal(
      {
        text: turboConfirm,
        title: title || confirmTitle || I18n.t('Confirmacion'),
        type: type || 'warning',
        showCancelButton: isEmpty(showCancel) ? true : showCancel,
        showLoaderOnConfirm: isEmpty(loader) ? true : loader,
        confirmButtonColor: '#fe1d12',
        confirmButtonText: buttonConfirm || I18n.t('Eliminar'),
        cancelButtonText: buttonCancel || I18n.t('Cancelar'),
        closeOnConfirm: isEmpty(close) ? true : close,
        closeOnCancel: true,
        html: true,
      },
      // OJOOOOOOOO!!!! Swal 1.1. es una puta mierda y hay que dejar la firma de esta función
      // tal cual está porque si no no llama cuando pulsan cancelar (busca por texto de la función):
      // https://github.com/t4t5/sweetalert/blob/5ca01b442b9884f83f2c85fc949ee33a05834049/dev/modules/handle-click.js#L109
      // eslint-disable-next-line func-names, prefer-arrow-callback
      function (isConfirmed) {
        if (isConfirmed) {
          originalElement.dispatchEvent(new Event('confirmado'));
        }
        resolve(isConfirmed);
      },
    );
  });
}

export function confirmarEliminar(opciones) {
  const ELIMINAR_DEFAULTS = {
    title: I18n.t('Confirmacion'),
    type: 'warning',
    text: I18n.t('seguro_eliminar_registro'),
    showCancelButton: true,
    cancelButtonText: I18n.t('Cancelar'),
    showConfirmButton: true,
    confirmButtonText: I18n.t('Eliminar'),
    confirmButtonColor: '#fe1d12',
    html: true,
  };

  const opts = Object.assign(ELIMINAR_DEFAULTS, opciones);

  return new Promise((resolve, _reject) => {
    swal(opts, (confirm) => {
      if (confirm === true) {
        resolve(confirm);
      }
    });
  });
}

export default {
  confirmar,
  confirmarEliminarFromElement,
  confirmarEliminar,
};
